import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the main page after 2 seconds
    const timer = setTimeout(() => {
      navigate("/main");
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, [navigate]);

  return (
    <div className="access-denied">
      <h1>Nice try cuh, you ain't slick</h1>
    </div>
  );
};

export default AccessDenied;